export const transportTypes = [
    {
        value: "1",
        label: "Φορτηγό Δημόσιας Χρήσης",
    },
    {
        value: "2",
        label: "Φορτηγό Ιδιωτικής Χρήσης",
    },
    {
        value: "3",
        label: "Πλοίο",
    },
    {
        value: "4",
        label: "Τρένο",
    },
    {
        value: "5",
        label: "Αεροπλάνο",
    },
    {
        value: "6",
        label: "Λοιπά Μεταφορικά Μέσα (π.χ. Δίκυκλα)",
    },
    {
        value: "7",
        label: "Άνευ",
    },
]
